module.exports = __webpack_public_path__ + "img/djstreamr.efd3893a.jpg";